import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, toHandlers as _toHandlers, mergeProps as _mergeProps, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "dialog-header"
};
const _hoisted_2 = ["id"];
const _hoisted_3 = {
  class: "dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CircleCloseFilled = _resolveComponent("CircleCloseFilled");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_button = _resolveComponent("el-button");
  const _component_pixelArtDetails = _resolveComponent("pixelArtDetails");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _component_EmailPDF = _resolveComponent("EmailPDF");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_dialog, {
    modelValue: $data.dialogVisible,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.dialogVisible = $event),
    "append-to-body": "",
    width: $data.computedDialogWidth,
    "align-center": "",
    "show-close": false,
    "close-on-click-modal": false
  }, {
    header: _withCtx(({
      close,
      titleId,
      titleClass
    }) => [_createElementVNode("div", _hoisted_1, [_createElementVNode("h4", {
      id: titleId,
      class: _normalizeClass([titleClass, "dialog-head-titlefont"])
    }, _toDisplayString($options.dialog_titel), 11, _hoisted_2), _createVNode(_component_el_button, {
      type: "danger",
      onClick: _withModifiers($options.handleclose, ["stop"]),
      class: "dialog-head-close"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_icon, {
        class: "el-icon--left"
      }, {
        default: _withCtx(() => [_createVNode(_component_CircleCloseFilled)]),
        _: 1
      }), _cache[1] || (_cache[1] = _createTextVNode(" Close "))]),
      _: 1
    }, 8, ["onClick"])])]),
    footer: _withCtx(() => [_createElementVNode("span", _hoisted_3, [_createVNode(_component_el_row, null, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 12
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: $options.onHandleBuyInAmazon,
          class: "dialog-font"
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode(" Buy In Amazon ")])),
          _: 1
        }, 8, ["onClick"])]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 12
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: $options.onHandleDetail,
          class: "dialog-font"
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode(" This Product ")])),
          _: 1
        }, 8, ["onClick"])]),
        _: 1
      })]),
      _: 1
    })])]),
    default: _withCtx(() => [_createVNode(_component_pixelArtDetails, _mergeProps({
      class: "dialog-image",
      show: $data.dialogVisible,
      currentEffectimg: $props.piexelImgInfo.smallimg,
      currentimgInfo: $props.piexelImgInfo,
      particelImg: $props.particelImg,
      onOnClicklike: $options.onClicklike,
      onOnGetPDF: $options.onDownloadPDF
    }, _toHandlers($options.eventListeners)), null, 16, ["show", "currentEffectimg", "currentimgInfo", "particelImg", "onOnClicklike", "onOnGetPDF"])]),
    _: 1
  }, 8, ["modelValue", "width"]), _createVNode(_component_EmailPDF, {
    ref: "emailpdf",
    pixelData: $props.builddata,
    pdfimage: $props.piexelImgInfo.smallimg,
    pdfimage_id: $props.piexelImgInfo.id,
    product_type: $props.piexelImgInfo.product_type
  }, null, 8, ["pixelData", "pdfimage", "pdfimage_id", "product_type"])], 64);
}